var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tiptap',{staticStyle:{"height":"900px"},attrs:{"extensions":_vm.extensions,"content":_vm.content,"placeholder":"Write something ...","readonly":_vm.readonly,"showMenubar":!_vm.readonly,"tooltip":!_vm.readonly},on:{"onUpdate":_vm.onUpdateEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }